import {Component, AfterViewInit, OnInit} from '@angular/core';
import {ROUTES} from './menu-items';
import {RouteInfo} from './sidebar.metadata';
import {Router, ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TokenStorageService} from '../../authentication/service/token-storage.service';

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  private roles: Array<string> = [];
  roleExpected;

  username: string;
  public sidebarnavItems: any[];

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private token: TokenStorageService
  ) {
  }

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  ngOnInit() {
    JSON.parse(sessionStorage.getItem('AuthAuthorities')).forEach(authority => {
      this.roles.push(authority.authority);
    });
    if (this.roles.includes('USER') && this.roles.length === 1) {
      this.roleExpected = 'USER';
    } else if (this.roles.includes('PERSONNEL') && this.roles.length === 1) {
      this.roleExpected = 'PERSONNEL';
    } else if (this.roles.includes('ADMIN') || this.roles.includes('OPERATOR')) {
      this.roleExpected = 'ADMIN';
    }

    this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
    this.username = this.transform(this.token.getUsername());

  }

  transform(value: string): string {
    if (value === null) {
      return 'Unknown';
    }
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  signOut() {
    window.sessionStorage.clear();
    this.router.navigateByUrl('/authentication/login');
  }

}
